/* eslint-disable */
import React, { useState } from 'react'
import range from 'lodash/range'

import capitalize from 'utils/capitalize'
import MultiSelectionDropdown from 'components/MultiSelectDropdown'
import { level1Threats } from 'constants/levelOneThreats'
import siteStatuses, { SITE_STATUS_CONFIRMED_ID } from 'constants/siteStatuses'
import { kbaClassificationList } from 'constants/kbaClassification'
import { kbaCriteria } from 'constants/kbaCriteria'
import ecoSystem from 'constants/ecoSystem'

import { FiltersContentContainer } from '../style'
import qs from 'query-string'

const formattedThreatsOptions = level1Threats.map((threat) => {
  return {
    label: threat.name,
    value: threat.id
  }
})

const formattedSiteAssessmentOptions = siteStatuses.filter((item) => {
  return item.id < SITE_STATUS_CONFIRMED_ID
}).map((status) => {
  return {
    label: status.name,
    value: status.id
  }
})

const formattedKbaClassificationOptions = kbaClassificationList.map((element) => {
  return {
    label: capitalize(element.name),
    value: element.id
  }
})

const formattedKbaCriteriaOptions = kbaCriteria.map((element) => {
  return {
    label: element.name,
    value: element.id
  }
})

const formattedSystemOptions = ecoSystem.map((element) => {
  return {
    label: element.label,
    value: element.value
  }
})

const currentYear = new Date().getFullYear()

const formattedYears = range(currentYear, 1949, -1).map((year) => {
  return {
    label: year.toString(),
    value: year
  }
})

const formattedKbaStatus = siteStatuses.slice(4).map((status) => {
  return {
    label: capitalize(status.name),
    value: status.id
  }
})

export const getCountryOptions = (selectedRegion, defaultRegionsOptions, defaultCountryOptions) => {
  if (selectedRegion.length === 0) {
    return defaultCountryOptions
  }

  return selectedRegion.map((value) => {
    const found = defaultRegionsOptions.find((element) => {
      return element.value === value
    })

    return found.countries.map((option) => {
      return {
        label: option.label,
        value: option.value,
        regionId: found.value
      }
    })
  }).flat()
}

export const getCountry = ([...countriesOptions], [...region], [...country], [...defaultRegionsOptions]) => {
  const selectedOptions = countriesOptions.filter((option) => {
    return country.some((element) => {
      return element === option.value
    })
  })

  const regWithoutCountry = region.filter((element) => {
    return selectedOptions.every((item) => {
      return item.regionId !== element
    })
  })

  return country.length === 0
    ? defaultRegionsOptions.filter((element) => {
      return region.some((id) => {
        return id === element.value
      })
    }).map((reg) => reg.countries).flat().concat(selectedOptions)
    : defaultRegionsOptions.filter((element) => {
      return regWithoutCountry.some((id) => {
        return id === element.value
      })
    }).map((reg) => reg.countries).flat().concat(selectedOptions)
}

export const getUrl = (
  queryCountry,
  system,
  threats,
  kbaStatus,
  kbaClassification,
  globalKbaCriteria,
  dateOfMostRecentAssessment,
  assessmentStatus
) => {
  return qs.stringify({
    country: queryCountry.map((option) => option.value).toString(),
    system: system.toString(),
    threats: threats.toString(),
    siteStatus: kbaStatus.concat(assessmentStatus).toString(),
    kbaClassification: kbaClassification.toString(),
    kbaCriterias: globalKbaCriteria.map((criteria) => {
      const found = kbaCriteria.find((element) => {
        return element.id === criteria
      })
      return found.name
    }).toString(),
    assessmentDate: dateOfMostRecentAssessment.toString()
  })
}

const SiteFiltersContent = ({
  item,
  lastItem,
  updateFilters,
  filterTitle,
  defaultRegionsOptions,
  defaultCountryOptions
}) => {
  const [region, setRegion] = useState(item.region)
  const [country, setCountry] = useState(item.country)
  const [system, setSystem] = useState(item.system)
  const [threats, setThreats] = useState(item.threats)
  const [assessmentStatus, setAssessmentStatus] = useState(item.assessmentStatus)
  const [kbaStatus, setKbaStatus] = useState(item.kbaStatus)
  const [kbaClassification, setKbaClassification] = useState(item.kbaClassification)
  const [globalKbaCriteria, setGlobalKbaCriteria] = useState(item.kbaCriterias)
  const [dateOfMostRecentAssessment, setDateOfMostRecentAssessment] = useState(item.dateOfMostRecentAssessment)
  const [regionInput, setRegionInput] = useState('')
  const [countryInput, setCountryInput] = useState('')
  const [threatsInput, setThreatsInput] = useState('')
  const [countriesOptions, setCountriesOptions] = useState(getCountryOptions(item.region, defaultRegionsOptions, defaultCountryOptions))


  const handleChangeRegion = (e) => {
    const url = getUrl(getCountry(countriesOptions, e, [], defaultRegionsOptions), system, threats, kbaStatus, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)
    setRegion(e)
    setCountry([])
    updateFilters({ ...item, region: [...e], country: [], url }, filterTitle)
    setCountriesOptions(getCountryOptions(e, defaultRegionsOptions, defaultCountryOptions))
  }

  const handleCountryChange = (e) => {
    const filtered = e.reduce((acc, cur) => {
      const curCountry = defaultCountryOptions.find((element) => {
        return element.value === cur
      })
      const curRegion = defaultRegionsOptions.find((element) => {
        return element.value === curCountry.regionId
      })
      const nonUniqRegion = acc.some((element) => {
        return element.value === curRegion.value
      })
      if (!nonUniqRegion) {
        acc.push(curRegion)
      }
      return acc
    }, [])

    const filteredIds = filtered.map((element) => {
      return element.value
    }).concat(region)

    const uniqArr = new Set(filteredIds)
    const url = getUrl(getCountry(countriesOptions, [...uniqArr], e, defaultRegionsOptions), system, threats, kbaStatus, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)

    setCountry(e)
    setRegion([...uniqArr])
    updateFilters({ ...item, country: e, region: [...uniqArr], url }, filterTitle)

  }

  const handleChangeSystem = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), e, threats, kbaStatus, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)

    setSystem(e)
    updateFilters({ ...item, system: e, url }, filterTitle)
  }

  const handleChangeThreats = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, e, kbaStatus, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)

    setThreats(e)
    updateFilters({ ...item, threats: e , url }, filterTitle)
  }

  const handleChangeAssessmentStatus = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, threats, kbaStatus, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, e)

    setAssessmentStatus(e)
    updateFilters({ ...item, assessmentStatus: e , url }, filterTitle)
  }

  const handleChangeKbaStatus = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, threats, e, kbaClassification, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)

    setKbaStatus(e)
    updateFilters({ ...item, kbaStatus: e , url }, filterTitle)
  }

  const handleChangeKbaClassification = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, threats, kbaStatus, e, globalKbaCriteria, dateOfMostRecentAssessment, assessmentStatus)

    setKbaClassification(e)
    updateFilters({ ...item, kbaClassification: e , url }, filterTitle)
  }

  const handleChangeGlobalKba = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, threats, kbaStatus, kbaClassification, e, dateOfMostRecentAssessment, assessmentStatus)

    setGlobalKbaCriteria(e)
    updateFilters({ ...item, kbaCriterias: e , url }, filterTitle)
  }

  const handleChangeDateOfAssessment = (e) => {
    const url = getUrl(getCountry(countriesOptions, region, country, defaultRegionsOptions), system, threats, kbaStatus, kbaClassification, globalKbaCriteria, e, assessmentStatus)

    setDateOfMostRecentAssessment(e)
    updateFilters({ ...item, dateOfMostRecentAssessment: e, url }, filterTitle)
  }

  const handleSearchRegion = (e) => {
    setRegionInput(e)
  }

  const handleSearchCountry = (e) => {
    setCountryInput(e)
  }

  const handleSearchThreats = (e) => {
    setThreatsInput(e)
  }

  return (
    <FiltersContentContainer lastItem={lastItem}>
      {defaultRegionsOptions.length > 0 && (
        <MultiSelectionDropdown
          dataTest='Region'
          marginTop='16px'
          label='region'
          secondStepOptions={defaultRegionsOptions}
          value={region}
          saveChanges={handleChangeRegion}
          infoTooltip='regionFilterHint'
          inputValue={regionInput}
          onInputChange={handleSearchRegion}
          isSearchable={true}
          placeholder='selectRegion'
          selectAllOption={true}
        />
      )}
      {countriesOptions.length > 0 && (
        <MultiSelectionDropdown
          dataTest='Country'
          marginTop='16px'
          label='countryLabel'
          secondStepOptions={countriesOptions}
          value={country}
          saveChanges={handleCountryChange}
          infoTooltip='countryFilterHint'
          inputValue={countryInput}
          onInputChange={handleSearchCountry}
          isSearchable={true}
          placeholder='selectCountry'
          selectAllOption={true}
        />
      )}
      <MultiSelectionDropdown
        dataTest='System'
        marginTop='16px'
        label='system'
        secondStepOptions={formattedSystemOptions}
        value={system}
        saveChanges={handleChangeSystem}
        infoTooltip='systemFilterHint'
        placeholder='selectSystem'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Threats'
        marginTop='16px'
        label='threats'
        secondStepOptions={formattedThreatsOptions}
        value={threats}
        saveChanges={handleChangeThreats}
        infoTooltip='threatsFilterHint'
        inputValue={threatsInput}
        onInputChange={handleSearchThreats}
        isSearchable={true}
        placeholder='selectThreat'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Assessment'
        marginTop='16px'
        label='assessment'
        secondStepOptions={formattedSiteAssessmentOptions}
        value={assessmentStatus}
        saveChanges={handleChangeAssessmentStatus}
        infoTooltip='assessmentStatusFilterHint'
        placeholder='selectAssessmentStatus'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='status'
        marginTop='16px'
        label='status'
        secondStepOptions={formattedKbaStatus}
        value={kbaStatus}
        saveChanges={handleChangeKbaStatus}
        infoTooltip='kbaStatusHint'
        placeholder='selectKbaStatus'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='KBA Classification'
        marginTop='16px'
        label='kbaClassification'
        secondStepOptions={formattedKbaClassificationOptions}
        value={kbaClassification}
        saveChanges={handleChangeKbaClassification}
        infoTooltip='kbaClassificationHint'
        placeholder='selectKbaClassification'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Global KBA criteria'
        marginTop='16px'
        label='globalKbaCriteria'
        secondStepOptions={formattedKbaCriteriaOptions}
        value={globalKbaCriteria}
        saveChanges={handleChangeGlobalKba}
        infoTooltip='globalKbaHint'
        placeholder='selectGlobalKbaCriteria'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Assessment date'
        marginTop='16px'
        label='assessmentDateFilter'
        secondStepOptions={formattedYears}
        value={dateOfMostRecentAssessment}
        saveChanges={handleChangeDateOfAssessment}
        infoTooltip='dateOfAssessmentHint'
        placeholder='selectAssessmentDate'
        selectAllOption={true}
        marginBottom='0'
      />
    </FiltersContentContainer>
  )
}

export default SiteFiltersContent
